// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Home = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="2px"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        className="st0"
        d="M46.1,25.9L25.9,5.7c-1-1-2.7-1-3.8,0L1.9,25.9c-1,1-1,2.7,0,3.8h5.4v12.2c0,1.5,1.2,2.7,2.7,2.7h10.5v-9.6h7v9.6h10.5c1.5,0,2.7-1.2,2.7-2.7v-12.2h5.4c1-1.1,1-2.8,0-3.8Z"
      />
    </svg>
  );
};
